import ParentsInfoOk from '../action-types/listingParentsInfoOk';

const initialState = {
  dam: true,
  sire: true,
};

const ParentsInfoOkReducer = (state = initialState, action) => {
  switch (action.type) {
    case ParentsInfoOk.SET_PARENT_DAM_INFO_OK: {
      const { infoIsOk } = action;
      return {
        ...state,
        dam: infoIsOk,
      };
    }
    case ParentsInfoOk.SET_PARENT_SIRE_INFO_OK: {
      const { infoIsOk } = action;
      return {
        ...state,
        sire: infoIsOk,
      };
    }
    default:
      return state;
  }
};

export default ParentsInfoOkReducer;
